import React from 'react'
import { Route, Routes } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import {Container, Row, Col} from 'react-bootstrap'
import MenuAdmin from '../components/menus/MenuAdmin'
import Dashboard from '../pages/admin/Dashboard'
import Businesses from '../pages/admin/businesses/Businesses'
import Movements from '../pages/admin/movements/Movements'
import Balance from '../pages/admin/balances/Balance'
import Logs from '../pages/admin/Logs'
import Bills from '../pages/admin/bills/Bills'
import BillExternals from '../pages/admin/billExternals/BillExternals'
import Version from '../version'
import Users from '../pages/admin/Users'

export default function AdminRouter () {
	return (
		<Container className='contenido-admin'>
			<MenuAdmin/>
			<Routes>
				<Route path="/dashboard" element={<Dashboard/>}/>
				<Route path="/providers" element={<Businesses typeBusiness="provider"/>}/>
				<Route path="/clients" element={<Businesses typeBusiness="client"/>}/>
				<Route path="/movements" element={<Movements/>}/>
				<Route path="/balance" element={<Balance/>}/>
				<Route path="/bills" element={<Bills typeBill="bill"/>}/>
				<Route path="/billExternals" element={<BillExternals/>}/>
				<Route path="/autobills" element={<Bills typeBill="autobill"/>}/>
				<Route path="/proformas" element={<Bills typeBill="proforma"/>}/>
				<Route path="/users" element={<Users/>}/>
				<Route path="/logs" element={<Logs/>}/>
				<Route path="*" element={<NotFoundPage />}/>
			</Routes>
			<Row>
                <Col className='text-center my-3'>
                    <Version />
                </Col>
            </Row>
		</Container>
	)
}